import * as React from 'react';

import Alert from 'antd/es/alert';

import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { DriverLicenseCards } from '@app/components/Pages/Admin/DriverLicenseCards/DriverLicenseCards';
import { DrivingLicense } from '@app/objects/DrivingLicense';

interface Props {
	renderButtons: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit: () => void;
}

interface DriverLicenseCardsWrapperProps extends Props {
	initialItems?: Array<DrivingLicense>;
}

const DriverLicenseStep: React.FC<Props> = (props) => {
	const { state: { items } } = useItemsProviderContext<DrivingLicense>();

	React.useEffect(() => {
		if (items?.length > 0 && items.some((dl) => dl.photoFront || dl.photoBack)) {
			handleSubmit();
		}
	}, []);

	const handleSubmit = () => {
		props.afterSubmit();
	};

	return <>
		<div className="contact-text mt10 mb10">
			<Alert
				message={<>
					Take photo of your
					{' '}
					<b>driving license</b>
					.
				</>}
				type="info"
			/>
		</div>
		<div className="patient-register-page__photo">
			<DriverLicenseCards cardPanelClassName="patient-register-page__wrapper" />
			{props.renderButtons(handleSubmit)}
		</div>
	</>;
};

const DriverLicenseCardsWrapper: React.FC<DriverLicenseCardsWrapperProps> = (props) => {
	return (
		<ItemsProvider<DrivingLicense>
			loadRequest="drivingLicensePageViewList"
			items={props.initialItems}
		>
			<DriverLicenseStep {...props} />
		</ItemsProvider>
	);
};

export default DriverLicenseCardsWrapper;
